export const DOWNLOAD_SET_SAMPLE_TYPE = "DOWNLOAD_SET_SAMPLE_TYPE";
export const DOWNLOAD_CLEAR_SAMPLE_TYPE = "DOWNLOAD_CLEAR_SAMPLE_TYPE";

export const DOWNLOAD_AUTOCOMPLETE_FILTER_REQUEST =
  "DOWNLOAD_AUTOCOMPLETE_FILTER_REQUEST";
export const DOWNLOAD_AUTOCOMPLETE_FILTER_SUCCESS =
  "DOWNLOAD_AUTOCOMPLETE_FILTER_SUCCESS";
export const DOWNLOAD_AUTOCOMPLETE_TREE_FETCH_REQUEST =
  "DOWNLOAD_AUTOCOMPLETE_TREE_FETCH_REQUEST";
export const DOWNLOAD_AUTOCOMPLETE_TREE_FETCH_SUCCESS =
  "DOWNLOAD_AUTOCOMPLETE_TREE_FETCH_SUCCESS";
export const DOWNLOAD_AUTOCOMPLETE_TREE_FETCH_ERROR =
  "DOWNLOAD_AUTOCOMPLETE_TREE_FETCH_ERROR";

export const DOWNLOAD_SAMPLES_FETCH_REQUEST = "DOWNLOAD_SAMPLES_FETCH_REQUEST";
export const DOWNLOAD_SAMPLES_FETCH_SUCCESS = "DOWNLOAD_SAMPLES_FETCH_SUCCESS";
export const DOWNLOAD_SAMPLES_FETCH_ERROR = "DOWNLOAD_SAMPLES_FETCH_ERROR";

export const DOWNLOAD_RECORD_COUNT_FETCH_REQUEST =
  "DOWNLOAD_RECORD_COUNT_FETCH_REQUEST";
export const DOWNLOAD_RECORD_COUNT_FETCH_SUCCESS =
  "DOWNLOAD_RECORD_COUNT_FETCH_SUCCESS";
export const DOWNLOAD_RECORD_COUNT_FETCH_ERROR =
  "DOWNLOAD_RECORD_COUNT_FETCH_ERROR";

export const DOWNLOAD_METADATA_FETCH_REQUEST =
  "DOWNLOAD_METADATA_FETCH_REQUEST";
export const DOWNLOAD_METADATA_FETCH_SUCCESS =
  "DOWNLOAD_METADATA_FETCH_SUCCESS";
export const DOWNLOAD_METADATA_FETCH_ERROR = "DOWNLOAD_METADATA_FETCH_ERROR";
export const DOWNLOAD_SET_COLS_SELECTED = "DOWNLOAD_SET_COLS_SELECTED";

export const DOWNLOAD_PREVIEW_FETCH_REQUEST = "DOWNLOAD_PREVIEW_FETCH_REQUEST";
export const DOWNLOAD_PREVIEW_FETCH_SUCCESS = "DOWNLOAD_PREVIEW_FETCH_SUCCESS";
export const DOWNLOAD_PREVIEW_FETCH_ERROR = "DOWNLOAD_PREVIEW_FETCH_ERROR";

export const DOWNLOAD_MAP_FETCH_REQUEST = "DOWNLOAD_MAP_FETCH_REQUEST";
export const DOWNLOAD_MAP_FETCH_SUCCESS = "DOWNLOAD_MAP_FETCH_SUCCESS";
export const DOWNLOAD_MAP_FETCH_ERROR = "DOWNLOAD_MAP_FETCH_ERROR";

export const DOWNLOAD_SET_START_DATE_FILTER = "DOWNLOAD_SET_START_DATE_FILTER";
export const DOWNLOAD_SET_END_DATE_FILTER = "DOWNLOAD_SET_END_DATE_FILTER";

export const DOWNLOAD_SET_PREVIEW_ROW_COUNT = "DOWNLOAD_SET_PREVIEW_ROW_COUNT";
export const DOWNLOAD_TOGGLE_AUTO_PREVIEW = "DOWNLOAD_TOGGLE_AUTO_PREVIEW";

export const DOWNLOAD_DISPLAY_COLUMNS_REQUEST =
  "DOWNLOAD_DISPLAY_COLUMNS_REQUEST";
export const DOWNLOAD_DISPLAY_COLUMNS_SUCCESS =
  "DOWNLOAD_DISPLAY_COLUMNS_SUCCESS";
export const DOWNLOAD_DISPLAY_COLUMNS_ERROR = "DOWNLOAD_DISPLAY_COLUMNS_ERROR";
export const DOWNLOAD_SET_SAMPLE_SEARCH = "DOWNLOAD_SET_SAMPLE_SEARCH";
export const APP_DRAWER_TOGGLE = "APP_DRAWER_TOGGLE";
export const DOWNLOAD_VIEW_CHANGED = "DOWNLOAD_VIEW_CHANGED";

export const DOWNLOAD_ADVSEARCH_VALUE = "DOWNLOAD_ADVSEARCH_VALUE";
export const DOWNLOAD_ADVSEARCH_OPERATOR = "DOWNLOAD_ADVSEARCH_OPERATOR";
export const DOWNLOAD_ADVSEARCH_COL = "DOWNLOAD_ADVSEARCH_COL";
export const DOWNLOAD_ADVSEARCH_ADD = "DOWNLOAD_ADVSEARCH_ADD";
export const DOWNLOAD_ADVSEARCH_REMOVE = "DOWNLOAD_ADVSEARCH_REMOVE";
export const DOWNLOAD_ADVSEARCH_SAVE = "DOWNLOAD_ADVSEARCH_SAVE";
export const DOWNLOAD_TOGGLE_ADVANCED = "DOWNLOAD_TOGGLE_ADVANCED";
export const DOWNLOAD_TOGGLE_TIMEZONE = "DOWNLOAD_TOGGLE_TIMEZONE";
export const DOWNLOAD_TIMEZONE_VALUE = "DOWNLOAD_TIMEZONE_VALUE";
export const DOWNLOAD_FILTER_CHANGED = "DOWNLOAD_FILTER_CHANGED";
export const DOWNLOAD_TOGGLE_COLUMN_PICKER = "DOWNLOAD_TOGGLE_COLUMN_PICKER";
export const DOWNLOAD_TOGGLE_RAW_HEADERS = "DOWNLOAD_TOGGLE_RAW_HEADERS";
export const DOWNLOAD_SET_INFINITE_OFFSET = "DOWNLOAD_SET_INFINITE_OFFSET";
export const DOWNLOAD_SET_SHOW_PREVIEW = "DOWNLOAD_SET_SHOW_PREVIEW";

export const DOWNLOAD_EXCEL_FILE_FETCH_REQUEST =
  "DOWNLOAD_EXCEL_FILE_FETCH_REQUEST";
export const DOWNLOAD_EXCEL_FILE_FETCH_SUCCESS =
  "DOWNLOAD_EXCEL_FILE_FETCH_SUCCESS";
export const DOWNLOAD_EXCEL_FILE_FETCH_ERROR =
  "DOWNLOAD_EXCEL_FILE_FETCH_ERROR";

export const DOWNLOAD_CHIP_SET = "DOWNLOAD_CHIP_SET";
export const DOWNLOAD_CHIP_SET_TEXT = "DOWNLOAD_CHIP_SET_TEXT";
export const DOWNLOAD_SET_HAS_REHYDRATED = "DOWNLOAD_SET_HAS_REHYDRATED";
export const DOWNLOAD_ADVSEARCH_UPDATE = "DOWNLOAD_ADVSEARCH_UPDATE";
export const DOWNLOAD_SET_FILTER_OPEN = "DOWNLOAD_SET_FILTER_OPEN";

export const FORM_SEARCH_REQUEST_SUCCESS = "FORM_SEARCH_REQUEST_SUCCESS";
export const FORM_HISTORY_REQUEST_SUCCESS = "FORM_SEARCH_HISTORY_SUCCESS";
export const SUBMIT_FORM_CHANGES_SUCCESS = "SUBMIT_FORM_CHANGES_SUCCESS";
export const ACKNOWLEDGE_FORM_CONTENT_CHANGED =
  "ACKNOWLEDGE_FORM_CONTENT_CHANGED";
export const FORM_CONTENT_CHANGED = "FORM_CONTENT_CHANGED";

export { WORKAREA_SET } from "features/workarea/constants";
